// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3LdQo","errors":"Errors_errors__l5Xs9"};